import Vue from 'vue'
import Vuex from 'vuex'

import streams from './streams'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    streams
  }
})

export default store
